import styled from 'styled-components';
import { Advantages } from './sections/Advantages';
import { Payments } from './sections/Payments';
import { TermsAndCookies } from './sections/TermsAndCookie';
import { SiteMap } from './sections/SiteMap';
import { useEffect, useState } from 'react';
import Cookie from 'js-cookie';
import RgpdBannerModal from 'Components/modals/RgdpBannerModal';
import OptinFooter from './sections/Optin/OptinFooter';
import { useTranslation } from 'react-i18next';
import { getCurrentLanguage } from '../../i18n/getCurrentLanguage';
import OptinFooterV2 from './sections/Optin/OptinFooterV2';
import { AdvantagesV2 } from './sections/Advantages/AdvantagesV2';
import { AppPromo } from './sections/AppPromo';
import { Reassurances } from './sections/Reassurances';
import { Inspirations } from './sections/Inspirations';
import { FooterBrand } from './sections/FooterBrand';

const FooterContainer = styled.div`
  padding: 0;
  transition: background-color 1s ease;
`;

const IntroBanner = styled.div`
  background-color: #faf8f4;
  padding: 1rem 1.6rem;
`;

const IntroText = styled.p`
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
  font-family: var(--font-primary);
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 22px;
  color: #9b9b9b;
`;

const MenuContainer = styled.div`
  background-color: #000;
  padding: 4.4rem 0 2.4rem;
  display: flex;
  flex-direction: column;
  row-gap: 3.2rem;

  color: #fff;

  a,
  a:visited {
    color: #fff !important;
  }

  a:hover {
    color: #dfff6d !important;
  }

  div,
  span,
  p,
  li {
    color: #fff;
  }
`;

type FooterProps = {
  external?: boolean | undefined;
  marginTop?: number;
};

export const FooterV2 = ({ external, marginTop }: FooterProps) => {
  const { t } = useTranslation('footer', { useSuspense: false });
  const [lang, setLang] = useState(false);

  const footerTranslate = {
    optin: {
      title: t('optin.title'),
      text: t('optin.text'),
      subText: t('optin.subText'),
      subText2: t('optin.subText2'),
      label: t('optin.label'),
    },
    advantages: {
      title: t('advantages.title'),
      title1: t('advantages.title1'),
      title2: t('advantages.title2'),
      brand: t('advantages.brand'),
      brandText: t('advantages.brandText'),
      payment: t('advantages.payment'),
      paymentText: t('advantages.paymentText'),
      returns: t('advantages.returns'),
      returnsText: t('advantages.returnsText'),
      support: t('advantages.support'),
    },
    inspirations: {
      titleStart: t('inspirations.titleStart', 'Nos dernières'),
      titleEmphasis: t('inspirations.titleEmphasis', 'inspirations'),
      titleEnd: t('inspirations.titleEnd', 'vous attendent'),
      text: t(
        'inspirations.text',
        'Retrouvez nos nouveautés, nos coups de cœur, des idées déco, mode & lifestyle, ainsi que les coulisses de Bazarchic sur les réseaux sociaux.'
      ),
      handle: t('inspirations.handle', '@BAZARCHIC'),
      buttonLabel: t('inspirations.buttonLabel', 'Suivez-nous !'),
    },
    reassurances: {
      returns: t('advantages.returns'),
      returnsText: t('advantages.returnsText'),
      brand: t('advantages.brand'),
      brandText: t('advantages.brandText'),
      payment: t('advantages.payment'),
      paymentText: t('advantages.paymentText'),
      support: t('advantages.support'),
      supportText: t('advantages.supportText'),
    },
    termsAndCookies: {
      termsOfSale: t('termsAndCookies.termsOfSale'),
      termsAndConditionsOfOffers: t(
        'termsAndCookies.termsAndConditionsOfOffers'
      ),
      cookieSettings: t('termsAndCookies.cookieSettings'),
    },
    introduction: t('introduction'),
    applicationText: 'Votre shopping en poche !',
    follow: 'Suivez-nous',
    appPromo: {
      title: t('appPromo.title', 'BazarChic, toujours'),
      titleEmphasis: t('appPromo.titleEmphasis', 'à portée de main.'),
      text: t(
        'appPromo.text',
        "Accédez aux ventes en avant-première, soyez alerté dès l'ouverture d'une sélection, vous ne manquez rien, et vous y êtes toujours en premier."
      ),
      buttonLabel: t('appPromo.buttonLabel', "Télécharger l'application"),
      note: t('appPromo.note', '4,7'),
      reviewCount: t('appPromo.reviewCount', '17 K notes'),
    },
  };
  useEffect(() => {
    if (!Cookie.get('RgpdBanner')) {
      RgpdBannerModal({ external });
    }

    getCurrentLanguage().then((lang) => {
      setLang(lang == 'fr-FR');
    });
  }, []);
  return (
    <FooterContainer>
      <Inspirations {...footerTranslate.inspirations} />
      <OptinFooterV2 {...footerTranslate.optin} />
      <Reassurances {...footerTranslate.reassurances} />
      <IntroBanner>
        <IntroText>{footerTranslate.introduction}</IntroText>
      </IntroBanner>
      <MenuContainer>
        <FooterBrand />
        <SiteMap />
        <Payments isAlma={lang} />
        <TermsAndCookies {...footerTranslate.termsAndCookies} />
      </MenuContainer>
    </FooterContainer>
  );
};
